import type { SearchResult } from './api.web';
import type { SearchContainerResult } from './types';

function mergeMatchedVia(
  a: SearchResult['matchedVia'],
  b: SearchResult['matchedVia'],
): SearchResult['matchedVia'] {
  const set = new Set([...a, ...b]);
  return [...set];
}

export function groupByContainer(results: SearchResult[]): SearchContainerResult[] {
  const byContainer = new Map<string, SearchContainerResult>();

  for (const row of results) {
    const key = row.containerId;
    const existing = byContainer.get(key);
    if (!existing) {
      byContainer.set(key, {
        containerId: row.containerId,
        containerType: row.containerType,
        title: row.containerTitle,
        snippet: row.snippet,
        matchCount: 1,
        matchedVia: [...row.matchedVia],
        topBlockId: row.blockId,
        score: row.score,
      });
      continue;
    }

    existing.matchCount += 1;
    existing.matchedVia = mergeMatchedVia(existing.matchedVia, row.matchedVia);
    if (row.score > existing.score) {
      existing.score = row.score;
      existing.snippet = row.snippet || existing.snippet;
      existing.topBlockId = row.blockId;
      existing.title = row.containerTitle;
    }
  }

  return [...byContainer.values()].sort((a, b) => b.score - a.score);
}
